import { FC } from "react"
import { RateflowCard } from "../../../../../../types"
import QuoteCard from "./quote-card"
import If from "../../../../if"
import QuoteDate from "./date"

interface Props {
  quoteId: string
  loanAmount: number
  timestamp?: number
  cards: RateflowCard[]
  onSelect: (id: string) => void
  hideTitle?: boolean
}

const QuotesGroup: FC<Props> = ({
  quoteId,
  loanAmount,
  timestamp,
  cards,
  onSelect,
  hideTitle = false
}) => {
  return (
    <div className="py-3">
      {!hideTitle && <QuoteDate timestamp={timestamp} quoteId={quoteId} />}

      <If
        condition={!!cards.length}
        then={
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mt-3">
            {cards.map(card => (
              <QuoteCard
                key={card.hash}
                data={{ ...card, loanAmount }}
                onSelect={onSelect}
              />
            ))}
          </div>
        }
        else={<div>No cards for this quote</div>}
      />
    </div>
  )
}

export default QuotesGroup
